import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';
import { LogIn, LogOut, Shield, Home, Briefcase } from 'lucide-react';

export default function Header() {
  const { user, isAuthenticated, isAdmin, isGestoria, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <header className="app-header">
      <Link to="/" className="app-header__logo">
        <Home size={22} />
        <div>
          <h1>SAEweb</h1>
          <span>Servicio de Atención al Empleado</span>
        </div>
      </Link>

      <div className="app-header__actions">
        {isAuthenticated ? (
          <>
            <span className="header-username" style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.82rem' }}>
              {user.first_name} {user.last_name}
            </span>
            {isAdmin && (
              <Link to="/gestion" className="btn btn--header">
                <Shield size={14} />
                <span className="btn--header-text">Gestión</span>
              </Link>
            )}
            {isGestoria && !isAdmin && (
              <Link to="/gestoria" className="btn btn--header">
                <Briefcase size={14} />
                <span className="btn--header-text">Gestoría</span>
              </Link>
            )}
            <button onClick={handleLogout} className="btn btn--header">
              <LogOut size={14} />
              <span className="btn--header-text">Salir</span>
            </button>
          </>
        ) : (
          <Link to="/login" className="btn btn--header">
            <LogIn size={14} />
            <span className="btn--header-text">Iniciar sesión</span>
          </Link>
        )}
      </div>
    </header>
  );
}
